const baseUrl = () => {
  const isProduction = !(window.origin.includes('localhost') || window.origin.includes('herokuapp'));

  if (isProduction) {
    return `https://parkwith.us`;
  } else {
    return `${window.origin}`;
  }
};

export default baseUrl;
